/**
 * --------------------------------------------------------------------------
 * Basic Modules: Gallery/Isotope.js
 * --------------------------------------------------------------------------
 */

//import Util from "./../util";

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG             = false;
const NAME              = 'galleryIsotope';
const DATA_KEY          = NAME;
const EVENT_KEY         = `.${DATA_KEY}`;
const LOG_KEY           = `[${NAME}]`;

const Default = {
};

const Event = {
    RESIZE              : `resize${EVENT_KEY} orientationchange${EVENT_KEY}`,
    SCROLL              : `scroll${EVENT_KEY}`,
    CLICK               : `click${EVENT_KEY}`,
};

const ClassName = {
    ACTIVE              : 'is-active',
    HIDDEN              : 'hidden',
};

const Selector = {
    TOGGLE              : `[data-toggle-gallery-isotope]`,
    ITEM                : '.item',
    SIZER_ITEM          : '.grid-sizer',
    GALLERY_SELECTOR    : '.gallery-selector',
    ZOOM_TRIGGER        : '.item-zoom-trigger',
    ITEM_IMAGE          : '.item-img',
    LOAD_MORE_BUTTON    : '[data-gallery-more-btn]',
    HIDDEN              : '.hidden',
};

const DataAttr = {
    SHOW                : 'show',
    LOAD                : 'load',
};

class GalleryIsotope {

    constructor(element, config) {

        DEBUG && console.log(LOG_KEY, 'Init');

        this._element = element;
        this._config  = this._getConfig(config);
        this._container = this._element.parentNode;

        this._initIsotope();
        this._initLightGallery();

        this._addEventListeners();
    }

    destroy() {
        $(this._element).off(EVENT_KEY);
        $.removeData(this._element, DATA_KEY);
        this._element = null;
    }

    // Private

    _initLightGallery() {
        $(this._element).lightGallery({
            selector: Selector.GALLERY_SELECTOR,
            thumbnail: false,
            pager: $(window).width() >= 768,
        });
    }

    _initIsotope() {

        const self = this;

        $(this._element).imagesLoaded(() => {

            // Init Isotope

            let initial_items = $(this._element).data(DataAttr.SHOW);
            let next_items = $(this._element).data(DataAttr.LOAD);
            let loadMoreBtn = $(this._container).find(Selector.LOAD_MORE_BUTTON);

            DEBUG && console.log(LOG_KEY, 'Number of initial items', initial_items);
            DEBUG && console.log(LOG_KEY, 'Number of next items', next_items);

            let $grid = $(this._element).isotope({
                itemSelector: Selector.ITEM,
                layoutMode: 'masonry',
                percentPosition: true,
                masonry: {
                    columnWidth: Selector.SIZER_ITEM,
                }
            });


            function showNextItems(pagination) {
                let itemsMax = $(Selector.HIDDEN).length;
                let itemsCount = 0;

                $(Selector.HIDDEN).each(function () {
                    if (itemsCount < pagination) {
                        $(this).removeClass(ClassName.HIDDEN);
                        itemsCount++;
                    }
                });

                if (itemsCount >= itemsMax) {
                    loadMoreBtn.hide();
                }

                $grid.isotope('layout');
            }

            function hideItems(pagination) {

                let items = $(self._element).find(Selector.ITEM);
                let itemsMax = items.length;
                let itemsCount = 0;

                DEBUG && console.log(LOG_KEY, 'Items to hide', pagination);
                DEBUG && console.log(LOG_KEY, 'Total number of items', itemsMax);

                items.each(function(idx, elem) {
                    if (itemsCount >= pagination) {
                        $(elem).addClass(ClassName.HIDDEN);
                    }
                    itemsCount++;
                });

                if (itemsCount < itemsMax || initial_items >= itemsMax) {
                    loadMoreBtn.hide();
                }

                $grid.isotope('layout');
            }

            loadMoreBtn.on(Event.CLICK, function(evt) {
                evt.preventDefault();
                showNextItems(next_items);
            });

            hideItems(initial_items);
        });
    }

    _handleZoomTriggerClick(event) {

        event.preventDefault();
        event.stopPropagation();

        let trigger = $(event.currentTarget);
        let itemImage = trigger.closest(Selector.ITEM).find(Selector.ITEM_IMAGE);
        itemImage.trigger('click'); // Do not use Event.CLICK here, the click event is bound by another library.
    }

    _addEventListeners() {
        $(this._element).find(Selector.ZOOM_TRIGGER).on(Event.CLICK, (event) => this._handleZoomTriggerClick(event));
    }

    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        GalleryIsotope._jQueryInterface.call($(selector || Selector.TOGGLE), config);
    }

    /**
     * jQuery Interface
     * @param config
     * @returns {*}
     */
    static _jQueryInterface(config) {
        return this.each(function() {
            const $this = $(this);
            let data    = $this.data(DATA_KEY);
            let _config = {
                ...Default,
                ...$this.data(),
                ...typeof config === 'object' && config ? config : {}
            };

            if (!data) {
                data = new GalleryIsotope(this, _config);
                $this.data(DATA_KEY, data);
            }

            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') {
                    throw new TypeError(`No method named "${config}"`);
                }
                data[config]();
            }
        });
    }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = GalleryIsotope._jQueryInterface;
$.fn[NAME].Constructor = GalleryIsotope;


export default GalleryIsotope;
